export const changeSalesGradeReducer = (state =' ', action) => {
    switch (action.type) {
      case "CHANGE_SALES_GRADE":
        return action.payload.salesGrade;
      default:
        return state;
    }
  };
  